module.exports = __webpack_public_path__ + "static/media/appointmate.fc252ff4.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/appointmate.PNG
// module id = 93
// module chunks = 0